// src/api.js
import axios from 'axios';

// Thay thế bằng URL thực tế của backend của bạn
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Thêm interceptor để tự động thêm token vào mọi request
api.interceptors.request.use(
  (config) => {
    // ✅ THAY ĐỔI TẠI ĐÂY: Lấy token trực tiếp từ sessionStorage
    const token = sessionStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;